import type { DynamicTableLayout } from "./types";
export interface Furniture {
  dynamicTable?: DynamicTableLayout;
  id: string;
  name: string;
  url: string;
  category: string;
  width?: number;
  height?: number;
}

export const FURNITURE_LIST: Furniture[] = [
  // BOOTHS
  {
    id: 'booth-1',
    name: 'Booth 1',
    url: '/images/furniture/Booths/Booth1.svg',
    category: 'booths',
    width: 69,
    height: 78
  },
  {
    id: 'booth-2',
    name: 'Booth 2',
    url: '/images/furniture/Booths/Booth2.svg',
    category: 'booths',
    width: 69,
    height: 78
  },
  {
    id: 'booth-3',
    name: 'Booth 3',
    url: '/images/furniture/Booths/Booth3.svg',
    category: 'booths',
    width: 61,
    height: 83
  },
  {
    id: 'booth-4',
    name: 'Booth 4',
    url: '/images/furniture/Booths/Booth4.svg',
    category: 'booths',
    width: 61,
    height: 83
  },
  {
    id: 'booth-5',
    name: 'Booth 5',
    url: '/images/furniture/Booths/Booth5.svg',
    category: 'booths',
    width: 61,
    height: 76
  },
  // CHAIRS
  {
    id: '1',
    name: 'Arm Chair',
    url: '/images/furniture/Chairs/Armchair.svg',
    category: 'chairs',
    width: 35,
    height: 31
  },
  {
    id: '2',
    name: 'Chair',
    url: '/images/furniture/Chairs/chair.svg',
    category: 'chairs',
    width: 32,
    height: 32
  },
  {
    id: '3',
    name: 'Chair no arms',
    url: '/images/furniture/Chairs/Chair_no_arms.svg',
    category: 'chairs',
    width: 35,
    height: 30
  },
  {
    id: '4',
    name: 'Stool',
    url: '/images/furniture/Chairs/stool.svg',
    category: 'chairs',
    width: 33,
    height: 30
  },
  // COUCH£S
  {
    id: 'couch-1',
    name: 'Couch',
    url: '/images/furniture/Couches/couch.svg',
    category: 'couches',
    width: 129,
    height: 52
  },
  {
    id: 'couch-2',
    name: 'Couch 2',
    url: '/images/furniture/Couches/couch2.svg',
    category: 'couches',
    width: 161,
    height: 73
  },
  {
    id: 'couch-3',
    name: 'Corner Couch',
    url: '/images/furniture/Couches/cornerCouch.svg',
    category: 'couches',
    width: 186,
    height: 127
  },
  {
    id: 'couch-4',
    name: 'Large Corner Couch',
    url: '/images/furniture/Couches/LargeCornerCouch.svg',
    category: 'couches',
    width: 265,
    height: 136
  },
  {
    id: 'couch-5',
    name: 'Large Couch',
    url: '/images/furniture/Couches/LargeCouch.svg',
    category: 'couches',
    width: 206,
    height: 52
  },
  {
    id: 'couch-6',
    name: 'U Couch',
    url: '/images/furniture/Couches/UCouch.svg',
    category: 'couches',
    width: 179,
    height: 91
  },
  // Items
  {
    id: 'item-1',
    name: 'Cabnet',
    url: '/images/furniture/Items/cabnet.svg',
    category: 'items',
    width: 30,
    height: 56
  },
  {
    id: 'item-2',
    name: 'Cabnets',
    url: '/images/furniture/Items/cabnets.svg',
    category: 'items',
    width: 30,
    height: 164
  },
  {
    id: 'item-3',
    name: 'Planter Box',
    url: '/images/furniture/Items/planterBox.svg',
    category: 'items',
    width: 30,
    height: 56
  },
  {
    id: 'item-4',
    name: 'Planter Boxes',
    url: '/images/furniture/Items/planterBoxes.svg',
    category: 'items',
    width: 30,
    height: 164
  },
  {
    id: 'item-5',
    name: 'Planter Pot',
    url: '/images/furniture/Items/planterPot.svg',
    category: 'items',
    width: 50,
    height: 50
  },
  {
    id: 'item-6',
    name: 'TV',
    url: '/images/furniture/Items/Tv.svg',
    category: 'items',
    width: 16,
    height: 93
  },
  // Tables
  {
    id: 'tables-1',
    name: 'Table Round 2.1',
    url: '/images/furniture/Tables/tableRound2.1.svg',
    category: 'tables',
    width: 60,
    height: 146
  },
  {
    id: 'tables-2',
    name: 'Table Round 2.2',
    url: '/images/furniture/Tables/tableRound2.2.svg',
    category: 'tables',
    width: 131,
    height: 95
  },
  {
    id: 'tables-3',
    name: 'Table Round 3.1',
    url: '/images/furniture/Tables/tableRound3.1.svg',
    category: 'tables',
    width: 103,
    height: 146
  },
  {
    id: 'tables-4',
    name: 'Table Round 4.1',
    url: '/images/furniture/Tables/tableRound4.1.svg',
    category: 'tables',
    width: 146,
    height: 146
  },
  {
    id: 'tables-5',
    name: 'Table Square',
    url: '/images/furniture/Tables/tableSquare2.svg',
    category: 'tables',
    width: 99,
    height: 99
  },
  {
    id: 'tables-6',
    name: 'Table Square 2',
    url: '/images/furniture/Tables/tableSquare2-1.svg',
    category: 'tables',
    width: 55,
    height: 141
  },
  {
    id: 'tables-7',
    name: 'Table Square 3',
    url: '/images/furniture/Tables/tableSquare3.svg',
    category: 'tables',
    width: 98,
    height: 141
  },
  {
    id: 'tables-8',
    name: 'Table Square 4',
    url: '/images/furniture/Tables/tableSquare4.svg',
    category: 'tables',
    width: 141,
    height: 141
  },
  {
    id: 'tables-8',
    name: 'Table Square 5',
    url: '/images/furniture/Tables/tableSquare5.svg',
    category: 'tables',
    width: 159,
    height: 150
  },
  // STAIRS
  {
    id: 'stairs-1',
    name: 'Stairs',
    url: '/images/furniture/Stairs/Stairs.svg',
    category: 'stairs',
    width: 497,
    height: 344
  },
  {
    id: 'stairs-2',
    name: 'Stairs 1',
    url: '/images/furniture/Stairs/Stairs-1.svg',
    category: 'stairs',
    width: 129,
    height: 202
  },
  {
    id: 'stairs-3',
    name: 'Stairs 2',
    url: '/images/furniture/Stairs/Stairs-2.svg',
    category: 'stairs',
    width: 202,
    height: 202
  },
  {
    id: 'stairs-4',
    name: 'Stairs 3',
    url: '/images/furniture/Stairs/Stairs-3.svg',
    category: 'stairs',
    width: 202,
    height: 202
  },
  {
    id: 'stairs-5',
    name: 'Stairs 4',
    url: '/images/furniture/Stairs/Stairs-4.svg',
    category: 'stairs',
    width: 202,
    height: 202
  },
  {
    id: 'stairs-6',
    name: 'Stairs 5',
    url: '/images/furniture/Stairs/Stairs-5.svg',
    category: 'stairs',
    width: 171,
    height: 204
  },
  {
    id: 'stairs-7',
    name: 'Stairs 6',
    url: '/images/furniture/Stairs/Stairs-6.svg',
    category: 'stairs',
    width: 171,
    height: 204
  },
  {
    id: 'stairs-8',
    name: 'Stairs 7',
    url: '/images/furniture/Stairs/Stairs-7.svg',
    category: 'stairs',
    width: 220,
    height: 531
  },
  {
    id: 'stairs-9',
    name: 'Stairs 8',
    url: '/images/furniture/Stairs/Stairs-8.svg',
    category: 'stairs',
    width: 202,
    height: 226
  },
  {
    id: 'stairs-10',
    name: 'Stairs Lift Combo',
    url: '/images/furniture/Stairs/Stairs - lift combo.svg',
    category: 'stairs',
    width: 309,
    height: 211
  }
  // TODO MUST BE LOADED FROM DB IN FUTURE
];
